export default __webpack_public_path__ + "static/media/char_body_prem_016.a1204df4.png";